import {
  FaBug,
  FaCode,
  FaGlobe,
  FaCheckCircle,
  FaCloud,
  FaExchangeAlt,
  FaGraduationCap,
  FaImages,
  FaTwitter,
  FaTelegram,
} from "react-icons/fa";

import { RiMenuLine, RiCloseLine } from "react-icons/ri";
import logo from "../../assets/svg/qwnt.png";
import MenuLink from "./MenuLink";
import { Link } from "react-router-dom";
import { useState } from "react";
import { toast } from "sonner";
import { FaMedium } from "react-icons/fa6";
import collapse from "../../assets/svg/sidebar/collapse.svg";
import caret from "../../assets/svg/sidebar/caret.svg";
import ai from "../../assets/svg/sidebar/ai.svg";
import check from "../../assets/svg/sidebar/check.svg";
const menuItems = [
  {
    title: "Pages",
    list: [
      {
        title: "RT-TraceMod",
        path: "/rt-tracemod",
        icon: <FaBug className="w-5 h-5" />,
      },
      {
        title: "CodeGen-AX",
        path: "/codegen-ax",
        icon: <FaCode className="w-5 h-5" />,
      },
      {
        title: "UI-RenderOps",
        path: "/ui-renderops",
        icon: <FaGlobe className="w-5 h-5" />,
      },
      {
        title: "SYN-VAL/ 42",
        path: "/syn-val-42",
        icon: <FaCheckCircle className="w-5 h-5" />,
      },
      {
        title: "DX-Pipeline",
        path: "/dx-pipeline",
        icon: <FaCloud className="w-5 h-5" />,
      },
      {
        title: "XLang-TX",
        path: "/xlang-tx",
        icon: <FaExchangeAlt className="w-5 h-5" />,
      },
      {
        title: "KN-Bridge",
        path: "/kn-bridge",
        icon: <FaGraduationCap className="w-5 h-5" />,
      },
      {
        title: "LDM-VizCore",
        path: "/ldm-vizCore",
        icon: <FaImages className="w-5 h-5" />,
      },
    ],
  },
  {
    title: "Socials",
    list: [
      {
        title: "Medium",
        path: "https://medium.com/@quillai",
        icon: <FaMedium className="w-5 h-5" />,
        isExternal: true,
      },
      {
        title: "Twitter",
        path: "#",
        icon: <FaTwitter className="w-5 h-5" />,
        onClick: () => toast.info("Coming Soon!"),
      },
      {
        title: "Telegram",
        path: "#",
        icon: <FaTelegram className="w-5 h-5" />,
        onClick: () => toast.info("Coming Soon!"),
      },
    ],
  },
];

const Sidebar = ({ isCollapsed, toggleCollapse }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <>
      <aside
        className={`lg:bg-[#0F1010] ${
          isCollapsed ? "h-[90px]" : "h-full"
        } md:border-b border-b border-[#2A3033] rounded-[16px] shadow-[0px_0px_0px_3.5px_rgba(255,255,255,0.04)] w-full flex lg:flex-col flex-row justify-between lg:items-start items-center lg:w-[280px] lg:px-0 px-4 lg:relative fixed z-50 transition-all duration-300`}
      >
        <div className="flex flex-row items-center justify-between w-full lg:flex-col md:items-start">
          <div className="h-[90px] flex justify-between items-center px-6 w-full relative">
            <div className="flex items-center gap-4">
              <Link to="/" className="flex items-center gap-1">
                <img src={logo} alt="logo" className="size-11" />

                <h4 className="mt-2 text-lg font-semibold text-white transition-all duration-300">
                  Qwnt AI
                </h4>
              </Link>
              <div
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  toggleDropdown();
                }}
                className="cursor-pointer"
              >
                <img
                  src={caret}
                  alt="caret"
                  className={`transition-transform duration-300 ${
                    isDropdownOpen ? "rotate-180" : ""
                  }`}
                />
              </div>
            </div>

            {isDropdownOpen && (
              <div className="absolute top-[85px] left-[26px] w-[412px] rounded-[12px] border border-white/10 bg-[#1B1B1B] shadow-[0_0_0_3px_rgba(255,255,255,0.06)] p-6 z-50">
                <ul className="flex flex-col gap-4 text-white">
                  <li className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="flex items-center justify-center w-10 h-10 border rounded-full border-white/10 bg-white/10">
                        <img src={ai} alt="ai" />
                      </div>
                      <div className="flex flex-col">
                        <span className="text-[18px] font-semibold">
                          Qwnt 1.0
                        </span>
                      </div>
                    </div>
                    <img className="w-6 h-6" src={check} alt="check" />
                  </li>
                  <li className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="flex items-center justify-center w-10 h-10 border rounded-full border-white/10 bg-white/10">
                        <img src={ai} alt="ai" />
                      </div>
                      <div className="flex flex-col">
                        <span className="text-[18px] font-semibold">
                          Qwnt 2.0
                        </span>
                      </div>
                    </div>
                    <span className="text-sm text[#D9BCFF] h-[36px] px-2 rounded-[24px] border border-white/10 bg-[rgba(210,186,255,0.06)] flex items-center">
                      Coming Soon
                    </span>
                  </li>
                </ul>
              </div>
            )}

            <div
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                toggleCollapse();
              }}
              className="z-10 cursor-pointer"
            >
              <img
                src={collapse}
                alt="collapse"
                className={`transition-transform duration-300 ${
                  isCollapsed ? "" : "rotate-180"
                }`}
              />
            </div>
          </div>

          {!isCollapsed && (
            <nav className="text-white w-full lg:block px-[1rem] transition-all duration-300 border-t border-white/[0.08] pt-6">
              <ul className="flex flex-col w-full gap-2">
                {menuItems[0].list.map((item) => (
                  <MenuLink item={item} key={item.title} />
                ))}
              </ul>
            </nav>
          )}

          <button onClick={toggleMobileMenu} className="block lg:hidden">
            <div className="w-10 h-10 bg-white/10 flex items-center justify-center rounded-[8px]">
              {isMobileMenuOpen ? (
                <RiCloseLine className="w-5 h-5 text-white" />
              ) : (
                <RiMenuLine className="w-5 h-5 text-white" />
              )}
            </div>
          </button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
